// Modules
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import * as Highcharts from 'highcharts';
import { getYearOf, getMonthOf, getDateOf } from '../../../../shared/utils/date-utils';

import { select, Store } from '@ngrx/store';

import { AppState } from '@app/general/store/reducers';
import * as DashboardSelectors from '@store/selectors/dashboard.selector';

// Store - Selectors
import { Subscription } from 'rxjs';

@Component({
    selector: 'sbi-cot-back-charts-component',
    templateUrl: './charts-component.component.html',
    standalone: false
})
export class ChartsComponentComponent implements OnInit, OnDestroy {
  private _subscriptions$: Subscription[] = [];

  @Input() xAxisName: string = '';
  @Input() yAxisName: string = '';

  Highcharts: typeof Highcharts = Highcharts; // required
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  chartOptions: Highcharts.Options;
  chartContainerMargin: number = 50;

  constructor(private _store$: Store<AppState>) {}

  ngOnInit() {
    this._store$
      .pipe(select(DashboardSelectors.selectDashboardAutoStatistics))
      .subscribe(data => {
        this.formatAndUpdateData(data);
        this._setInitialChartSize();
        this._updateChartSize();
      });
  }

  ngOnDestroy() {
    // fix del bug de highcharts que no elimina el chart destruido y genera que el array tenga varios valores como undefined
    if (Highcharts.charts[0] == undefined) {
      Highcharts.charts.splice(0, 1);
    }
    this._subscriptions$.forEach(sub => sub.unsubscribe());
  }

  public formatAndUpdateData(dashboardStatistics) {
    const data = [];
    if (dashboardStatistics && dashboardStatistics.length) {
      const year = getYearOf(dashboardStatistics[0].fecha);
      const month = getMonthOf(dashboardStatistics[0].fecha);
      const day = getDateOf(dashboardStatistics[0].fecha);

      const pointStart = Date.UTC(year, month, day);

      data.push(
        {
          name: 'Cotizadas',
          data: [],
          type: 'area',
          pointStart: pointStart,
          pointInterval: 24 * 3600 * 1000,
        },
        {
          name: 'Pagadas no emitidas',
          data: [],
          type: 'area',
          pointStart: pointStart,
          pointInterval: 24 * 3600 * 1000,
        },
        {
          name: 'Emitidas',
          data: [],
          type: 'area',
          pointStart: pointStart,
          pointInterval: 24 * 3600 * 1000,
        },
        {
          name: 'Perdidas',
          data: [],
          type: 'area',
          pointStart: pointStart,
          pointInterval: 24 * 3600 * 1000,
        }
      );
      for (const e of dashboardStatistics) {
        data[0].data.push(e.cotizadas);
        data[1].data.push(e.pagas_no_emitidas);
        data[2].data.push(e.emitidas);
        data[3].data.push(e.perdidas);
      }

      this.chartOptions = {
        chart: {
          renderTo: 'container',
        },
        title: {
          text: '',
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value:%d-%m}',
            rotation: 65,
            align: 'left',
          },
          title: {
            text: this.xAxisName,
          },
        },
        tooltip: {
          xDateFormat: '%d-%m',
          shared: true,
        },
        yAxis: {
          title: {
            text: this.yAxisName,
          },
        },
        series: data,
      };
    }
  }

  // Funcion publica para ajustar el tamanio del chart segun el tamanio de la pantalla
  private _setInitialChartSize(): void {
    setTimeout(() => {
      const node = document.querySelector('.private-page-container');
      if (!node) {
        //The node we need does not exist yet.
        //Wait 500ms and try again
        window.setTimeout(this._setInitialChartSize, 500);
        return;
      }
      const chartWidth = node.clientWidth - this.chartContainerMargin;

      if (Highcharts.charts && Highcharts.charts[0])
        Highcharts.charts[0].setSize(chartWidth, window.innerHeight, true);
    }, 500);
  }

  // Funcion publica para cambiar el ancho del chart cuando se colapsa o se muestra el menu
  private _updateChartSize(): void {
    const node = document.querySelector('.left-side');
    if (!node) {
      //The node we need does not exist yet.
      //Wait 500ms and try again
      window.setTimeout(this._updateChartSize, 500);
      return;
    }
    const observer = new MutationObserver(() => {
      setTimeout(() => {
        const chartWidth =
          document.querySelector('.private-page-container').clientWidth -
          this.chartContainerMargin;
        if (Highcharts.charts && Highcharts.charts[0])
          Highcharts.charts[0].setSize(chartWidth, window.innerHeight, true);
      }, 1000);
    });

    observer.observe(node, {
      attributes: true,
      childList: true,
      characterData: true,
    });
  }
}
